// extracted by mini-css-extract-plugin
export default {"cardWrapper":"p4AthhP6x0srk1utIRl7","title":"H4sZ3Fj0c5jTPIqAYx9J","date":"pPVKQ_tE2qw8SHsXDK9k","readButton":"vAdEwkIZW2vNNqIzjkZb","link":"nVTqORSUW5aSan9ytwkU"};